import React from "react";

const pct = (sell, cost) => (sell > 0 ? Math.round(((sell - cost) / sell) * 100) : 0);

const tone = (m) => {
  if (m < 15) return { cls: "bg-red-50 text-red-700 border-red-200", label: "Thin" };
  if (m < 30) return { cls: "bg-amber-50 text-amber-700 border-amber-200", label: "Low" };
  return { cls: "bg-emerald-50 text-emerald-700 border-emerald-200", label: "Healthy" };
};

export const marginOf = (p) => (p.cj_cost == null ? null : Math.min(pct(p.price, p.cj_cost), pct(p.wholesale_price, p.cj_cost)));

export const MarginBadge = ({ product }) => {
  if (product.cj_cost == null) {
    return <span className="text-xs text-slate-400" data-testid={`margin-badge-${product.product_id}`}>No cost data</span>;
  }
  const retail = pct(product.price, product.cj_cost);
  const wholesale = pct(product.wholesale_price, product.cj_cost);
  const t = tone(Math.min(retail, wholesale));
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-semibold whitespace-nowrap ${t.cls}`}
      title={`CJ cost $${product.cj_cost.toFixed(2)} · retail margin ${retail}% · wholesale margin ${wholesale}%`}
      data-testid={`margin-badge-${product.product_id}`}
    >
      {t.label} · R {retail}% / W {wholesale}%
    </span>
  );
};
